import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import mixpanel from 'mixpanel-browser';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import { CookieUtilWrapperService } from './services/cookie-util-wrapper.service';
import { RedirectOnLoginService } from './services/redirect-on-login.service';
import { TableStatefulFiltersService } from './services/table-stateful-filters.service';
import { FeatureFlagsService } from './services/feature-flags.service';
import { ContextWidgetStorageService } from './components/context-widget/services/context-storage.utils.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cookieService: CookieUtilWrapperService,
    private localStorage: LocalStorageService,
    private redirectOnLoginService: RedirectOnLoginService,
    private tableStatefulFiltersService: TableStatefulFiltersService,
    private featureFlagService: FeatureFlagsService,
    private contextWidgetStorageService: ContextWidgetStorageService,
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err) => {
        if (
          [401, 503]?.includes(err.status) &&
          !(
            window.location.href.includes('/forgot-password') ||
            window.location.href.includes('/reset-password') ||
            window.location.href.includes('/sso-logout')
          ) &&
          !request.url.includes('/tunnel/')
        ) {
          // logout()
          this.cookieService.delete('selection', '/');
          this.localStorage.removeFacetsStore();
          this.tableStatefulFiltersService.flushFilterStates();
          this.contextWidgetStorageService.clearContextWidgetStorage();
          // Before navigating to the login page, store the last visited URL to be used as the redirect URL
          // after the user successfully logs in.
          this.redirectOnLoginService.preserveRedirectURL().then((data) => {
            let logoutUrl = this.featureFlagService.getLogoutUrl();
            try {
              const localStorageLogoutURL = localStorage?.getItem('logoutUrl');
              if (!logoutUrl && localStorageLogoutURL) {
                logoutUrl = localStorageLogoutURL;
              }
            } catch (err) {}
            this.resetProductTools();
            if (err?.url?.includes('api/me')) {
              try {
                localStorage?.removeItem('logoutUrl');
              } catch (err) {}
            }
            if (logoutUrl) {
              window.location.href = `${window.location.origin}/${logoutUrl}`;
            } else {
              this.router.navigate(['/login']);
            }
          });
        }
        return throwError(err);
      }),
    );
  }

  resetProductTools() {
    mixpanel.reset();
    window?.['productFruits']?.services?.destroy();
  }
}
